export var CssStyleRules;!function(s){s[s.CUE_WRAPPER=0]="CUE_WRAPPER",s[s.CUE=1]="CUE"}(CssStyleRules||(CssStyleRules={}));